import React from 'react';
import Icon from '../../../components/AppIcon';

const ResultComparisonView = ({ comparisonData }) => {
  const calculateChange = (current, previous) => {
    if (!previous || previous === 0) return null;
    const change = ((current - previous) / previous) * 100;
    return change?.toFixed(1);
  };

  const getChangeColor = (change) => {
    if (!change) return 'text-muted-foreground';
    return parseFloat(change) > 0 ? 'text-destructive' : 'text-success';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl font-semibold text-foreground">Serial Lab Comparison</h3>
        <Icon name="GitCompare" size={24} color="var(--color-primary)" />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-2 md:px-4 text-xs md:text-sm font-semibold text-foreground">
                Test
              </th>
              <th className="text-left py-3 px-2 md:px-4 text-xs md:text-sm font-semibold text-foreground">
                Current
              </th>
              <th className="text-left py-3 px-2 md:px-4 text-xs md:text-sm font-semibold text-foreground">
                Previous
              </th>
              <th className="text-left py-3 px-2 md:px-4 text-xs md:text-sm font-semibold text-foreground">
                Change
              </th>
              <th className="text-left py-3 px-2 md:px-4 text-xs md:text-sm font-semibold text-foreground">
                Trend
              </th>
            </tr>
          </thead>
          <tbody>
            {comparisonData?.map((item) => {
              const change = calculateChange(item?.current, item?.previous);
              return (
                <tr key={item?.id} className="border-b border-border">
                  <td className="py-3 px-2 md:px-4">
                    <span className="text-xs md:text-sm font-medium text-foreground">
                      {item?.testName}
                    </span>
                  </td>
                  <td className="py-3 px-2 md:px-4">
                    <span className="text-xs md:text-sm font-semibold text-foreground">
                      {item?.current} {item?.unit}
                    </span>
                  </td>
                  <td className="py-3 px-2 md:px-4">
                    <span className="text-xs md:text-sm text-muted-foreground">
                      {item?.previous} {item?.unit}
                    </span>
                  </td>
                  <td className="py-3 px-2 md:px-4">
                    {change && (
                      <span className={`text-xs md:text-sm font-semibold ${getChangeColor(change)}`}>
                        {parseFloat(change) > 0 ? '+' : ''}
                        {change}%
                      </span>
                    )}
                  </td>
                  <td className="py-3 px-2 md:px-4">
                    {change && (
                      <Icon
                        name={parseFloat(change) > 0 ? 'TrendingUp' : 'TrendingDown'}
                        size={16}
                        className={getChangeColor(change)}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ResultComparisonView;